import { deepCompare } from '../../../Core/utils';
import { validateWebsiteURL } from '../../Misc/helpers/formatting/url.helper';
import { LinkTypesEnum } from '../enums/link-types.enum';

export class SocialLinkModel {
    type: LinkTypesEnum = LinkTypesEnum.twitter;
    url: string;
    text?: string;

    constructor(type: LinkTypesEnum, url: string, text?: string) {
        this.type = type;
        this.url = url;
        this.text = text;
    }

    clone(): SocialLinkModel {
        return new SocialLinkModel(this.type, this.url, this.text);
    }

    toApi(): SocialLinkModel {
        return {
            type: this.type,
            url: this.url,
            text: this.text,
        } as SocialLinkModel;
    }

    isUrlValid(): boolean {
        return validateWebsiteURL(this.url);
    }

    equals(other: SocialLinkModel): boolean {
        if (!other) {
            return false;
        }

        if (this.type !== other.type) {
            return false;
        }

        if (!deepCompare(this.url, other.url, { emptyChecker: 'all' })) {
            return false;
        }

        if (!deepCompare(this.text, other.text, { emptyChecker: 'all' })) {
            return false;
        }

        return true;
    }
}
